import React, { Component } from 'react'
import { FormGroup, Label, Input, Col, CustomInput } from 'reactstrap';

const FormInput = (props) => {
    let inputElement = null;
    const inputClasses = [];

    if (props.invalid && props.shouldValidate && props.submitted) {
        inputClasses.push('invalid')
    }


    switch (props.type) {
        case ('text' || 'number' || 'textarea'):
            inputElement = <Input
                bsSize="sm"
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.changed}
            />
            break;

        case ('hidden'):
            inputElement = <Input
                bsSize="sm"
                type={props.type}
                name={props.name}
                value={props.value}
            />
            break;

        case ('plaintext'):
            inputElement = <Input
                bsSize="sm"
                type={'text'}
                name={props.name}
                value={props.value}
                disabled
            />
            break;

        case ('file'):
            inputElement = <Input
                bsSize="sm"
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                // accept=".csv"
                accept={props.accept}
                onChange={(e) => props.getDataFunc(e)}
                // style={{ border: '1px solid' }}
            />;
            break;

        case ('select'):
            inputElement =

                (<Input
                    bsSize="sm"
                    className={`${inputClasses.join(' ')}`}
                    type={props.type}
                    name={props.name}
                    id={props.name}
                    value={props.value}
                    onChange={props.changed}
                >
                    <option className="  text-capitalize" key={0} value=''>Select</option>
                    {
                        props.data.options.map(
                            (option, i) => {
                                if (props.name == props.selects[0]) {
                                    return <option className=" text-capitalize" key={i} value={option[props.selectKey[0]]}> {option[`${props.selects[0]}`]} </option>
                                }
                                else if (props.name == props.selects[1]) {
                                    return <option className=" text-capitalize" key={i} value={option[props.selectKey[1]]}> {option[`${props.selects[1]}`]} </option>
                                }
                                else if (props.name == props.selects[2]) {
                                    return <option className=" text-capitalize" key={i} value={option[props.selectKey[2]]}> {option[`${props.selects[2]}`]} </option>
                                }
                            }
                        )
                    }
                </Input>);
            break;
        default:
            inputElement = <Input
                bsSize="md"
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.changed}
                min={props.min}
                max={props.max}
            />
    }

    return (
        <React.Fragment>
            {
                (props.invalid && props.submitted) &&
                <div className="col-12">
                    <p className="text-right text-danger mb-0 ">*{props.label}
                        &nbsp;{props.error}</p>
                </div>
            }

            {
                props.name === 'chooseFile' &&
                    <div style={{width: '100%'}}>
                        {inputElement}
                    </div>
            }

            {
                props.type !== 'textarea' && props.name !== 'chooseFile' &&
                <div className={" pt-0 mt-1  text-uppercase pl-md-3 pl-0 col-4 "}
                    htmlFor={props.name}

                    size="sm">{props.label}
                    {
                        props.required &&
                        <span className="text-danger">*</span>
                    }
                </div>
            }

            {
                props.name !== 'chooseFile' &&
                <div className={props.type !== 'textarea' ? " col-7 pl-0 pr-0 " : " col-12 pl-0 pr-0"}>
                    {inputElement}
                </div>
            }

            {
                <div className={"col-1"}>
                    {
                        !props.invalid && props.submitted &&
                        < i className=" text-success fas fa-check-circle"></i>
                    }
                    {
                        props.invalid && props.submitted &&
                        <i className="text-danger fas fa-times-circle"></i>
                    }
                </div>
            }

            {/* // </FormGroup> */}
        </React.Fragment >
    );
}

export default FormInput;


// WEBPACK FOOTER //
// ./src/_components/common/Form/formInput.jsx